import {
  Button,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Paper,
  TextField,
} from "@material-ui/core";
import Autocomplete from "@material-ui/lab/Autocomplete";
import { Field, Form, Formik } from "formik";
import { capitalize } from "lodash";
import React from "react";
import { useHistory } from "react-router-dom";
import * as Yup from "yup";
import useApi from "../../../../../../hooks/api";
import useAuth from "../../../../../../hooks/auth";
import { formatCurrency } from "../../../../../../utils/formatters";
import { DateField } from "../../../../../ui/form_fields";

const readOnlyFields = [
  { name: "nome_credor", label: "Nome do credor" },
  { name: "tribunal", label: "Tribunal" },
  { name: "valor_precatorio", label: "Valor do precatório" },
  { name: "numero_precatorio", label: "Número do precatório" },
];

const validationSchema = Yup.object({
  assigned_to: Yup.mixed().required("Usuário responsável deve ser escolhido"),
});

const NewTradeModal = ({ closeModal, precatorio, assertiva, model, type }) => {
  const history = useHistory();
  const { post } = useApi();

  const {
    user: { id: assigned_by, name: userName, type: userType, client_users },
  } = useAuth();

  const { dadosPessoais, telefones, emails } = assertiva || {};

  const {
    pessoa: { cpfCnpj, nome: nome_credor },
    id: prospect_model_id,
  } = model;

  const {
    loaValorEmCentavos,
    valorEmCentavos,
    id: precatorio_id,
    devedorNome: devedor,
    tribunalAcronimo: tribunal,
    anoVencimento: ano_vencimento,
    numero: numero_precatorio,
  } = precatorio;

  const initialValues = {
    precatorio_id,
    cpf_cnpj: cpfCnpj || dadosPessoais?.documento,
    nome_credor,
    devedor,
    tribunal,
    numero_precatorio,
    valor_precatorio: loaValorEmCentavos || valorEmCentavos,
    ano_vencimento,
    contacts: {
      email: emails || [],
      wired: telefones?.filter(({ tipo }) => tipo === "fixo") || [],
      mobile: telefones?.filter(({ tipo }) => tipo === "movel") || [],
    },
    prospect_model_id,
    prospect_model_type: capitalize(type),
    assigned_by,
    assigned_to: { id: assigned_by, name: userName },
    due_date: null,
  };

  const handleSubmit = async (values, { setSubmitting }) => {
    setSubmitting(true);

    try {
      const {
        data: { id: trade_id },
      } = await post("/v1/crm/trades", values);

      alert("A negociação foi criada. Redirecionando para sua nova Negociação");
      history.push("/negocios", { trade_id });
    } catch {
      alert(
        "Atenção! Não conseguimos criar uma nova Oportunidade de negócios. Tente novamente mais tarde. Se o problema persistir, entre em contato conosco."
      );

      setSubmitting(false);
    }
  };

  return (
    <DialogContent>
      <DialogTitle disableTypography={true} className="qd-new-trade-title">
        Criar nova negociação
      </DialogTitle>

      <DialogContentText className="qd-new-trade-header">
        Será criada uma nova negociação com os seguintes dados:
      </DialogContentText>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({
          isSubmitting,
          isValid,
          dirty,
          errors,
          values,
          setFieldValue,
          submitForm,
        }) => (
          <>
            <Form className="smart-form" component={Paper}>
              {userType === "supervisor" && (
                <div className="mb-15">
                  <Field
                    name="assigned_to"
                    component={Autocomplete}
                    options={client_users}
                    getOptionLabel={({ name }) => name || ""}
                    getOptionSelected={({ id }) => id}
                    value={values.assigned_to}
                    renderInput={(input) => (
                      <TextField
                        {...input}
                        label="Usuário responsável"
                        variant="standard"
                        error={!!errors.assigned_to}
                        helperText={errors.assigned_to}
                        fullWidth
                      />
                    )}
                    onChange={(_ev, value) => {
                      setFieldValue("assigned_to", value);
                    }}
                    fullWidth
                  />
                </div>
              )}

              {readOnlyFields.map(({ name, label }) => (
                <div className="mb-15" key={name}>
                  <TextField
                    name={name}
                    label={label}
                    value={
                      name === "valor_precatorio"
                        ? formatCurrency(initialValues[name])
                        : initialValues[name]
                    }
                    fullWidth
                    disabled
                  />
                </div>
              ))}

              <Field
                label="Data limite"
                variant="standard"
                name="due_date"
                component={DateField}
                fullWidth
              />

              <DialogActions>
                <div className="mt-30">
                  <Button
                    disabled={isSubmitting}
                    onClick={closeModal}
                    color="primary"
                    variant="outlined"
                  >
                    Cancelar
                  </Button>

                  <Button
                    style={{ marginLeft: "10px" }}
                    onClick={submitForm}
                    type="submit"
                    color="primary"
                    variant="outlined"
                    disabled={(!isValid && dirty) || isSubmitting}
                  >
                    {isSubmitting ? "Criando..." : "Criar"}
                  </Button>
                </div>
              </DialogActions>
            </Form>
          </>
        )}
      </Formik>
    </DialogContent>
  );
};

export default NewTradeModal;
